/* Cinta bucal landing — behaviour. Each feature isolated in try/catch so one
   failure never disables the others (esp. sticky bar + scroll-to-buy). */
(function () {
  'use strict';
  var doc = document;
  function $(s, r) { return (r || doc).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); }
  function on(el, ev, fn, o) { if (el) el.addEventListener(ev, fn, o); }

  function ready(fn) {
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---------- smooth scroll to buy area ---------- */
  function scrollToBuy() {
    var el = $('#cbl-compra');
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.scrollY - 90;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
  function scrollToId(id) {
    var el = doc.getElementById(id);
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.scrollY - 90;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  ready(function () {

    /* ============ COUNTDOWN TOP BAR ============ */
    try {
      $all('[data-cbl-countdown]').forEach(function (bar) {
        var hours = parseFloat(bar.getAttribute('data-cbl-hours')) || 48;
        var deadline = Date.now() + hours * 3600 * 1000;
        var nodes = {
          d: $('[data-cd="d"]', bar), h: $('[data-cd="h"]', bar),
          m: $('[data-cd="m"]', bar), s: $('[data-cd="s"]', bar)
        };
        function p(n) { return String(n).padStart(2, '0'); }
        function tick() {
          var diff = deadline - Date.now();
          if (diff <= 0) { deadline = Date.now() + hours * 3600 * 1000; diff = hours * 3600 * 1000; }
          var d = Math.floor(diff / 86400000); diff -= d * 86400000;
          var h = Math.floor(diff / 3600000); diff -= h * 3600000;
          var m = Math.floor(diff / 60000); diff -= m * 60000;
          var s = Math.floor(diff / 1000);
          if (nodes.d) nodes.d.textContent = p(d);
          if (nodes.h) nodes.h.textContent = p(h);
          if (nodes.m) nodes.m.textContent = p(m);
          if (nodes.s) nodes.s.textContent = p(s);
        }
        tick(); setInterval(tick, 1000);
        var close = $('[data-cbl-close]', bar);
        on(close, 'click', function () { bar.style.display = 'none'; });
      });
    } catch (e) { /* countdown optional */ }

    /* ============ GALLERY ============ */
    try {
      $all('[data-cbl-gallery]').forEach(function (g) {
        var slides = $all('[data-cbl-slide]', g);
        var thumbs = $all('[data-cbl-thumb]', g);
        var dots = $all('[data-cbl-dot]', g);
        var stage = $('.cbl-gallery', g);
        var pills = $('.cbl-gpills', g);
        var n = slides.length;
        if (n <= 1) { g.classList.add('cbl-gsingle'); }
        var idx = 0;
        function show(i) {
          idx = (i + n) % n;
          slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
          thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); });
          dots.forEach(function (dt, k) { dt.classList.toggle('is-active', k === idx); });
          // floating benefit pills only belong on the first image — they would
          // otherwise cover the text baked into the other infographic photos
          if (pills) pills.style.display = (idx === 0) ? '' : 'none';
          // keep the active thumbnail visible inside its (mobile) horizontal strip,
          // scrolling only the strip — never the page
          var at = thumbs[idx];
          if (at && at.parentNode) {
            var strip = at.parentNode;
            if (strip.scrollWidth > strip.clientWidth + 4) {
              var target = at.offsetLeft - (strip.clientWidth / 2) + (at.clientWidth / 2);
              try { strip.scrollTo({ left: target, behavior: 'smooth' }); } catch (e) { strip.scrollLeft = target; }
            }
          }
        }
        thumbs.forEach(function (t, k) { on(t, 'click', function () { show(k); }); });
        dots.forEach(function (dt, k) { on(dt, 'click', function () { show(k); }); });
        on($('[data-cbl-prev]', g), 'click', function () { show(idx - 1); });
        on($('[data-cbl-next]', g), 'click', function () { show(idx + 1); });
        // swipe
        var x0 = null;
        if (stage) {
          on(stage, 'pointerdown', function (e) { x0 = e.clientX; });
          on(stage, 'pointerup', function (e) {
            if (x0 == null) return;
            var dx = e.clientX - x0; x0 = null;
            if (Math.abs(dx) < 40) return;
            show(dx < 0 ? idx + 1 : idx - 1);
          });
        }
        // story circles jump to a media index
        $all('[data-cbl-story]', g.closest('[data-cbl-hero]') || doc).forEach(function (st) {
          on(st, 'click', function () {
            var i = parseInt(st.getAttribute('data-cbl-story'), 10) || 0;
            show(Math.min(i, n - 1));
          });
        });
        show(0);
      });
    } catch (e) { /* gallery optional */ }

    /* ============ ACCORDIONS (hero + faq) ============ */
    try {
      $all('[data-cbl-acc-head]').forEach(function (head) {
        on(head, 'click', function () {
          var item = head.closest('[data-cbl-acc-item]');
          if (!item) return;
          var panel = $('[data-cbl-acc-panel]', item);
          var open = item.classList.toggle('is-open');
          head.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (panel) panel.style.maxHeight = open ? (panel.scrollHeight + 'px') : '0px';
        });
      });
    } catch (e) {}

    /* ============ BEFORE / AFTER SLIDER ============ */
    try {
      $all('[data-cbl-ba]').forEach(function (stage) {
        var before = $('[data-cbl-ba-before]', stage);
        var handle = $('[data-cbl-ba-handle]', stage);
        var inner = $('[data-cbl-ba-inner]', stage);
        var pos = 50, dragging = false;
        function set(pct) {
          pos = Math.max(0, Math.min(100, pct));
          if (before) before.style.width = pos + '%';
          if (inner) inner.style.width = (100 / Math.max(pos, 0.001) * 100) + '%';
          if (handle) handle.style.left = pos + '%';
        }
        function fromX(clientX) {
          var r = stage.getBoundingClientRect();
          set(((clientX - r.left) / r.width) * 100);
        }
        on(stage, 'pointerdown', function (e) { dragging = true; fromX(e.clientX); });
        on(window, 'pointerup', function () { dragging = false; });
        on(window, 'pointermove', function (e) { if (dragging) { e.preventDefault(); fromX(e.clientX); } }, { passive: false });
        set(50);
      });
    } catch (e) {}

    /* ============ REVIEWS: show more ============ */
    try {
      $all('[data-cbl-more-btn]').forEach(function (btn) {
        on(btn, 'click', function () {
          var wrap = $('[data-cbl-more]', btn.closest('.cbl-rv'));
          if (wrap) wrap.classList.toggle('is-open');
        });
      });
    } catch (e) {}

    /* ============ SCROLL-TO-BUY buttons ============ */
    try {
      $all('[data-cbl-goto-buy]').forEach(function (b) { on(b, 'click', function (ev) { ev.preventDefault(); scrollToBuy(); }); });
      $all('[data-cbl-goto]').forEach(function (b) {
        on(b, 'click', function (ev) { ev.preventDefault(); scrollToId(b.getAttribute('data-cbl-goto')); });
      });
    } catch (e) {}

    /* ============ MYSTERY DISCOUNT POPUP ============ */
    try {
      var pop = $('[data-cbl-popup]');
      if (pop) {
        var delay = parseFloat(pop.getAttribute('data-cbl-delay')) || 6;
        var tab = $('[data-cbl-popup-tab]');
        var shown = false, dismissed = false;
        function openPop() { if (!dismissed) { pop.classList.add('is-open'); shown = true; } }
        function closePop() { pop.classList.remove('is-open'); dismissed = true; if (tab) tab.classList.add('is-visible'); }
        setTimeout(function () { if (!shown && !dismissed) openPop(); }, delay * 1000);
        $all('[data-cbl-popup-close]', pop).forEach(function (b) { on(b, 'click', closePop); });
        on(pop, 'click', function (e) { if (e.target === pop) closePop(); });
        on($('[data-cbl-popup-cta]', pop), 'click', function () { closePop(); scrollToBuy(); });
        on(tab, 'click', function () { dismissed = false; openPop(); if (tab) tab.classList.remove('is-visible'); });
      }
    } catch (e) {}

    /* ============ STICKY MOBILE BAR ============ */
    try {
      var sticky = $('[data-cbl-sticky]');
      if (sticky) {
        var buy = $('#cbl-compra');
        var footer = doc.querySelector('footer') || $('.cbl-nl');
        function updateSticky() {
          var showThresh = document.documentElement.scrollHeight * 0.4;
          var scrolled = window.scrollY > showThresh;
          var buyGone = true;
          if (buy) { var br = buy.getBoundingClientRect(); buyGone = br.bottom < 80; }
          var footIn = false;
          if (footer) { footIn = footer.getBoundingClientRect().top < (window.innerHeight - 20); }
          var visible = (scrolled || buyGone) && !footIn;
          sticky.classList.toggle('is-visible', visible);
        }
        window.addEventListener('scroll', updateSticky, { passive: true });
        window.addEventListener('resize', updateSticky);
        updateSticky(); // stays hidden on load (top of page)

        // mirror the main buy-area price (rendered by Kaching / theme)
        var priceOut = $('[data-cbl-sticky-price]', sticky);
        if (priceOut && buy) {
          function findPrice() {
            var cands = $all('.price-item--regular, .price__regular .price-item, .money, [class*="price"]', buy);
            for (var i = 0; i < cands.length; i++) {
              var tx = (cands[i].textContent || '').trim();
              if (/[0-9].*[€$]|[€$].*[0-9]/.test(tx)) return tx;
            }
            return '';
          }
          function syncPrice() { var p = findPrice(); if (p) priceOut.textContent = p; else priceOut.style.display = 'none'; }
          syncPrice();
          var mo = new MutationObserver(syncPrice);
          mo.observe(buy, { childList: true, subtree: true, characterData: true });
        }
        // sticky button only scrolls to buy — never adds to cart
        on($('[data-cbl-sticky-btn]', sticky), 'click', function (ev) { ev.preventDefault(); scrollToBuy(); });
      }
    } catch (e) {}

  });
})();
